import React, { useState, useEffect } from "react";
import {Typography,CircularProgress }    from '@material-ui/core';
import ThemeControls from "../../../Component/AllThemesControl.js";
import FormScopeDefiner from "../../../Component/Forms/FormScopeDefiner.js";
import CreateCard from "../../../Component/CreateCard.js"

//import fieldsData       from './viewTableColumn.json';
//import EditJson from './EditFormJson.json';
//import masterJSON       from './masterJson.json';
//import contextJson      from './searchJson.json';

import DataTable from "../../../Component/DataTable/GenerateTable.js";
import {FormJSONCreateContext} from '../../../Component/FormJSONCreateContext.js';
//import Success Page  
import SuccessPage      from '../../../Component/SuccessPage.js';
//import for Navigation 
import {useNavigate}    from 'react-router-dom';
import { APIUIGET } from '../../../services/APIServices';



const apiContextVar = ""; 
// const apiContextVar = "carrierOnBoard"; 
const contextHeading = "Carrier";
const policyLabelOnDelete="";
let masterJson = null;
let viewData = null;
let editJson = null;
let searchJson = null;
let editInrowJson = null;
function View(props) {
  const { getContext } = props;  // Access context from props
  const {useStyles} = ThemeControls;
  const classes=useStyles();
  const contextClasses = classes.topSpace;
  const [successRender,setSuccessRender] = React.useState(undefined);
  const [successPageData,setSuccessPageData] = React.useState(undefined);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [contextObjective,setContextObjective] = React.useState("search");

  const [alertData, setAlertData] = React.useState([]);
  const [filteredData, setFilteredData] = React.useState([]);
  const [reportData, setReportData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [apiContextObj, setApiContextObj] = React.useState();

  // const [apiContextVar, setApiContextVar] = useState();
  
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);
     
     // let apiContextObj;//fieldsData.config;
      let [contextJson, setContextJson] = useState([]);
      let [ cardMenuJson, setCardMenuJson] = useState([]);
      const [apiPath,setApiPath] = React.useState();

      function handelnavigate(event, link) {
        event.preventDefault();
        navigate(link)
      }

  const { 
          searchJsonPath = '/vconfig/'+getContext+'/search.json',
          editJsonPath =   '/vconfig/'+getContext+'/edit.json',
          masterJsonPath = '/vconfig/'+getContext+'/save.json', 
          viewTablePath =  '/vconfig/'+getContext+'/view.json',
          editInrowJsonPath =  '/vconfig/'+getContext+'/editInrow.json',
          cardMenuJsonPath =   '/vconfig/'+getContext+'/menu.json'
      } = props;
  
      useEffect(() => {
        const loadJsonFiles = async () => {
            try {
                setLoading(true);
                setCardMenuJson([]);
                setContextJson([]);
                setApiContextObj([]);
                setApiPath([]);
                setContextObjective([]);
                const [masterJsonModule, viewTableModule,searchJsonModule,editJsonModule,editInrowJsonModule,cardMenuJsonModule] = await Promise.all([
                   // APIGET(/* webpackChunkName: "masterJson" */ `${masterJsonPath}`),
                   // import(/* webpackChunkName: "viewTable" */ `${viewTablePath}`)
                   APIUIGET(masterJsonPath),
                   APIUIGET(viewTablePath),
                   APIUIGET(searchJsonPath),
                   APIUIGET(editJsonPath),
                   APIUIGET(editInrowJsonPath),
                   APIUIGET(cardMenuJsonPath)
                ]);
                
                // Get default exports
                masterJson = masterJsonModule;
                viewData = viewTableModule;
                editJson = editJsonModule;
                editInrowJson = editInrowJsonModule;
                searchJson = searchJsonModule;
                contextJson = searchJson;
                cardMenuJson = cardMenuJsonModule;
                if(cardMenuJson){
                  //RoutesArray = cardMenuJson;
                  setCardMenuJson(cardMenuJson);
                  //setLoading(false);
                  //return ;
                }
                if(viewData && viewData.config){
                  setApiContextObj(viewData.config);
                  if( viewData.config.apiContextSearch)
                    setApiPath(viewData.config.apiContextSearch);
                  if(viewData.config.searchFormStyle)
                    setContextObjective(viewData.config.searchFormStyle);
                }
                //contextJson(searchJson);
                
                if(editJson === null || editJson === undefined){
                  editJson=masterJson;
                }
                 
                if(contextJson === null || contextJson === undefined){
                  //contextJson = viewData;
                  //contextJson = viewData;
                }
                if(contextJson !== null && contextJson !== undefined)
                Object.keys(contextJson).forEach((key,index) =>{
                  if(key!=="xioFEConfig"){
                    if(contextJson[key].fields){                    
                      contextJson[key].fields.map((field)=>{
                        if(field.field_type==="custom"){
                          field.field_value = "{}";
                        } else if(field.field_type !== "hidden"&&field.field_default_value){
                          field.field_value = field.field_default_value
                          field.id = ""
                        } else{
                          field.field_value = "";
                          field.id = "";
                        }
                        return field;
                      });
                    }else{ }
                  }else{
                    if (key === "xioFEConfig") {
                      if (key.config && key.config.apiContextSearch) {
                        // setApiContextVar(key.config.apiContextSearch);
                      }
                    }
                  }
                });
              
                
                setContextJson(contextJson);
                //setFieldsData(viewData);
                setLoading(false);
            } catch (err) {
                console.error("Failed to load JSON files:", err);
                setError(err.message);
                setLoading(false);
            }
        };
        
        loadJsonFiles();
    }, [ masterJsonPath, viewTablePath, searchJsonPath, editJsonPath, editInrowJsonPath, cardMenuJsonPath]);









  const authentication = {
    "actions": {
      "action":true,
      "checkBox":true,
      "disable": {
        "edit": false,
        "delete": false,
        "view": false,
        "download":{
          "dwld":true,
          "pdf":true,
          "xlsx":true,
          "xls":true
        },
      },
      "hide": {
        "edit": false,
        "delete": false,
        "view": false,
        "download": {
          "dwld":true,
          "pdf":true,
          "xlsx":true,
          "xls":true
        },
      }
    }
  }
  
  //for navigation 
  let navigate = useNavigate();
  function renderSuccessPage(props){
    setSuccessPageData(props)
    setSuccessRender(1);
    console.log('Success Rander is Rendering..')
  }
  function navigateToCreate(){
    navigate(successPageData.createLink)
    // handleClose();
    setSuccessRender(undefined);
    return null;
  }
  function navigateToView(){
     
    navigate(successPageData.viewLink);
    setSuccessRender(undefined);
  }

 

const apiString = (getContext,data) => {
  setApiPath(getContext);
  setReportData(data)
};

  if (loading) {
        return (
            <div className={classes.main} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                <CircularProgress />
                <Typography variant="body1" style={{ marginLeft: '10px' }}>
                    Loading form configuration...
                </Typography>
            </div>
        );
  }
  
        if (error) {
        return (
            <div className={classes.main}>
                <Typography variant="h6" color="error">
                    Error loading form: {error}
                </Typography>
            </div>
        );
  }

if(contextJson!==null){
    return (
    <FormJSONCreateContext.Provider value={{renderSuccessPage,masterJson}}>
      <div className={classes.main}> 
        {(cardMenuJson.length >0)?<CreateCard cardJson={[...cardMenuJson]} /> :(successRender&&successPageData)?
            <SuccessPage
            policyName ={successPageData.policyName}
            actionName = {successPageData.actionName}
            createPolicyLink = {navigateToCreate}
            viewPolicyLink = {navigateToView}
            createButtonText = {successPageData.createButtonText}
            viewButtonText = {successPageData.viewButtonText}
            paragraphText = {successPageData.paragraphText}
          />
        :

        <>
          {/* <Typography variant="h6" className={classes.marginChange}>
              {contextHeading}
            </Typography> */}
          <div className={classes.formTabCard}>
            <div className={classes.formTabheading}>
                        <div className="flexIcon">
                          <h1>{contextJson['xioFEConfig'].page_label}</h1>
                        </div>
                        {contextJson['xioFEConfig'].btn_name && (
                          <button className={classes.subBtn} onClick={(event) => handelnavigate(event, contextJson['xioFEConfig'].btn_link)}>
                            {contextJson['xioFEConfig'].btn_name}
                          </button>
                        )}
              </div>
          <div className={classes.searchForm}>
          
        
          <FormScopeDefiner value={{contextJson,apiContextVar,apiContextObj,contextHeading,contextClasses,contextObjective}} apiString={apiString}/>
          </div>
          <DataTable setTableData={setFilteredData}  
                          searchQuery={searchQuery} 
                          viewJson={viewData} 
                          apiContextObj={apiContextObj} 
                          apiContext={apiPath} 
                          createJson={masterJson} 
                          setAlertData={setAlertData} 
                          EditJson={editJson}
                          EditInrowJson={editInrowJson} />
          </div>
        </> 
                
        }
    </div>
  </FormJSONCreateContext.Provider>
    );
  }
}

export default View;
